__turbopack_context__.v({
  "buttonsContainer": "-2FPDG_buttonsContainer",
  "overline": "-2FPDG_overline",
  "wrapper": "-2FPDG_wrapper",
});
